/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAvailTractDetail.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/avail-tract-detail";

export class AutogenModelAvailTractDetail<RowType extends ModelRow> extends Endpoint<RowType, RowAvailTractDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAvailTractDetail extends ModelRow<RowAvailTractDetailFields> {
	constructor(values?: Partial<RowAvailTractDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAvailTractDetailFields {
	avail_tract_id: string;
	available_date: Date;
	carrier_email: string;
	carrier_fax: string;
	carrier_id: string;
	carrier_phone: string;
	city_id: number;
	comments: string;
	company_id: string;
	contact: string;
	date_entered: Date;
	dispatcher: string;
	distance_radius: number;
	entered_by: string;
	entered_by_name: string;
	equipment_type_id: string;
	expires_date: Date;
	extracted_capacity: string;
	id: string;
	load_to_city: string;
	load_to_city_id: number;
	load_to_state: string;
	location_city: string;
	location_state: string;
	location_zip: string;
	location_zone_id: string;
	"movement.id": string;
	number_units: number;
	recurring_tractor_id: number;
	status: string;
	status_color: string;
	teams: string;
	tractor_id: string;
	only_active: boolean;
}

